const body = "flex-1 min-h-0 flex flex-col p-2 md:p-6 gap-4";

const logAreaWrapper = "flex-1 min-h-0";

const logArea = "rounded-xl bg-muted p-3 md:p-4 md:h-full overflow-hidden border border-border/30 shadow-inner";

export { body, logAreaWrapper, logArea };
